import { useSyncExternalStore, type KeyboardEvent } from 'react';
import { Button, Dialog } from '@one/ui';
import { knopfTexte, tastenAktion, type Rueckfragen } from './rueckfrage';

/**
 * Zeigt die älteste offene Rückfrage aus `ctx.ui.confirm` als modalen Dialog der Shell.
 * Fokusfalle, aria-modal, Titel als Überschrift und Fokus-Rückgabe kommen aus `Dialog`
 * (@one/ui); Esc, Klick auf den Hintergrund und „Schließen“ brechen ab, Enter bestätigt.
 */
export function Rueckfragedialog({ rueckfragen }: { rueckfragen: Rueckfragen }) {
  const frage = useSyncExternalStore(rueckfragen.abonnieren, rueckfragen.aktuell);
  if (!frage) return null;

  const texte = knopfTexte(frage.optionen);
  const antworten = (ok: boolean) => rueckfragen.antworten(frage.id, ok);

  const taste = (e: KeyboardEvent<HTMLDivElement>) => {
    const ziel = e.target as HTMLElement;
    const aktion = tastenAktion(
      e.key,
      ziel.closest('button, a[href], input, select, textarea') !== null,
      e.nativeEvent.isComposing,
    );
    if (!aktion) return;
    e.preventDefault();
    // Esc meldet auch `Dialog` über onClose; die zweite Antwort verpufft (gleiche Nummer).
    antworten(aktion === 'bestaetigen');
  };

  return (
    // Schlüssel je Rückfrage: Die nächste in der Warteschlange bekommt einen frischen
    // Dialog (Fokus wieder auf dem Dialog, Rückgabe an das ursprüngliche Element).
    <div key={frage.id} onKeyDown={taste} className="shell-rueckfrage">
      <Dialog
        open
        title={frage.optionen.title}
        onClose={() => antworten(false)}
        footer={
          <>
            <Button variant="secondary" onClick={() => antworten(false)}>
              {texte.abbrechen}
            </Button>
            <Button onClick={() => antworten(true)}>{texte.bestaetigen}</Button>
          </>
        }
      >
        <p className="shell-rueckfrage-text">{frage.optionen.message}</p>
      </Dialog>
    </div>
  );
}
